/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderate_ContentInputs */

const en_moderate_content = /** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderate Content`)
};

const id_moderate_content = /** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderasi Konten`)
};

/** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */
const es_moderate_content = en_moderate_content;

/** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */
const fr_moderate_content = en_moderate_content;

/** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */
const de_moderate_content = en_moderate_content;

/** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */
const ja_moderate_content = en_moderate_content;

/** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */
const zh_moderate_content = en_moderate_content;

/** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */
const ar_moderate_content = en_moderate_content;

/** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */
const it_moderate_content = en_moderate_content;

/** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */
const ru_moderate_content = en_moderate_content;

/** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */
const pt_moderate_content = en_moderate_content;

/** @type {(inputs: Moderate_ContentInputs) => LocalizedString} */
const ko_moderate_content = en_moderate_content;

/**
* | output |
* | --- |
* | "Moderate Content" |
*
* @param {Moderate_ContentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const moderate_content = /** @type {((inputs?: Moderate_ContentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderate_ContentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderate_content(inputs)
	if (locale === "es") return es_moderate_content(inputs)
	if (locale === "fr") return fr_moderate_content(inputs)
	if (locale === "de") return de_moderate_content(inputs)
	if (locale === "ja") return ja_moderate_content(inputs)
	if (locale === "zh") return zh_moderate_content(inputs)
	if (locale === "ar") return ar_moderate_content(inputs)
	if (locale === "id") return id_moderate_content(inputs)
	if (locale === "it") return it_moderate_content(inputs)
	if (locale === "ru") return ru_moderate_content(inputs)
	if (locale === "pt") return pt_moderate_content(inputs)
	return ko_moderate_content(inputs)
});